import type React from 'react';
import { useEffect } from 'react';

import { useProgress } from '@/context/progress';
import { usePersonalInformationProgressStep } from '@/features/onboarding/personal-information/hooks/use-progress-step';
import BaseLayout from '@/layouts/base';

const FcaQuestionnaireLayout = (props: React.ComponentPropsWithoutRef<typeof BaseLayout>) => {
  const { setCurrentStep } = useProgress();
  const progressStep = usePersonalInformationProgressStep();

  useEffect(() => {
    return setCurrentStep(progressStep, 0.9);
  }, [progressStep, setCurrentStep]);

  return <BaseLayout {...props} />;
};
FcaQuestionnaireLayout.displayName = 'FcaQuestionnaireLayout';

export default FcaQuestionnaireLayout;
